var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1028",
    "data-name": "Grupo 1028",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.036,
    height: 56.066,
    viewBox: "0 0 56.036 56.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2728",
    "data-name": "Ret\\xE2ngulo 2728",
    width: 56.036,
    height: 56.066
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1027",
    "data-name": "Grupo 1027",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1704",
    "data-name": "Caminho 1704",
    d: "M0,13.614A13.636,13.636,0,0,1,3.785,4.37C4.651,3.443,5.548,2.535,6.5,1.694a6.767,6.767,0,0,1,9.057.091Q18.359,4.409,21,7.213a6.966,6.966,0,0,1-.306,9.693c-1.434,1.386-1.54,2.316-.443,4A50.519,50.519,0,0,0,35.47,36.016a2.478,2.478,0,0,0,3.468-.458,7,7,0,0,1,10.2-.238q2.378,2.35,4.73,4.727a6.9,6.9,0,0,1,.005,10.042,20.675,20.675,0,0,1-4.731,4.043c-5.043,2.7-10.062,2.624-14.825-.548A114.591,114.591,0,0,1,2.367,21.633,14.035,14.035,0,0,1,0,13.614m42.054,40.36c.01.055.019.11.029.166,1.317-.272,2.661-.449,3.944-.834,2.852-.857,4.871-2.894,6.739-5.074a4.682,4.682,0,0,0-.313-6.726q-2.335-2.349-4.685-4.684a4.954,4.954,0,0,0-7.367.15,4.48,4.48,0,0,1-5.988.775A51.831,51.831,0,0,1,21.254,25.792c-1.046-1.345-2.018-2.753-2.956-4.176a4.412,4.412,0,0,1,.784-5.972,4.925,4.925,0,0,0,.383-7.092C17.762,6.752,16,5,14.2,3.3a4.559,4.559,0,0,0-5.952-.335A25.915,25.915,0,0,0,5.211,5.824,11.8,11.8,0,0,0,4.021,20.456a114.041,114.041,0,0,0,8.255,10.9,114.387,114.387,0,0,0,23.09,20.523,12.031,12.031,0,0,0,6.687,2.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1705",
    "data-name": "Caminho 1705",
    d: "M119.772,28.439c0,.375.013.75,0,1.124-.031.713-.392,1.115-.988,1.125-.624.01-1.007-.422-1.047-1.141-.064-1.141-.08-2.29-.231-3.421A23.566,23.566,0,0,0,112.073,14,24.81,24.81,0,0,0,98.944,5.6a22.3,22.3,0,0,0-5.806-.7c-.692.006-1.1-.317-1.169-.869A.963.963,0,0,1,92.979,2.9a19.54,19.54,0,0,1,5.7.553q15.716,4.1,20.317,19.7a19.364,19.364,0,0,1,.529,2.623c.132.883.183,1.777.27,2.667l-.021,0",
    transform: "translate(-64.58 -2.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1706",
    "data-name": "Caminho 1706",
    d: "M111.586,48.5v.187c0,.885-.353,1.35-1.024,1.354s-1.014-.444-1.05-1.343a16.315,16.315,0,0,0-7.629-13.568,15.631,15.631,0,0,0-8.58-2.635c-.835-.015-1.27-.327-1.323-.931-.059-.683.385-1.133,1.169-1.131a16.344,16.344,0,0,1,6.275,1.158,18.726,18.726,0,0,1,11.849,14.06c.2.931.245,1.894.361,2.842l-.049.006",
    transform: "translate(-64.592 -21.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1707",
    "data-name": "Caminho 1707",
    d: "M103.369,68.054a3.828,3.828,0,0,1-.245.942.892.892,0,0,1-1.081.412.951.951,0,0,1-.743-.888,17.426,17.426,0,0,0-.361-2.335,8.293,8.293,0,0,0-7.361-6.062c-.228-.018-.457-.034-.684-.062a.979.979,0,0,1-.98-1.06A.989.989,0,0,1,93,58.042a10.4,10.4,0,0,1,4.056.863,10.644,10.644,0,0,1,6.309,9.149",
    transform: "translate(-64.547 -40.761)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8ba6098eb813650ee3cda5b9f55567f5.svg";
export { ForwardRef as ReactComponent };